import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { MailConfig, MailConfigUpdateRequest, PentestMailConfigUpdateRequest } from '../models';
import { map } from 'rxjs/operators';
import { DemoStore } from '../stores';
import { DemoDataService } from './demo-data.service';

@Injectable({ providedIn: 'root' })
export class MailConfigService {
  private readonly httpClient = inject(HttpClient);
  private readonly demoStore = inject(DemoStore);
  private readonly demoDataService = inject(DemoDataService);

  getCustomerMailConfig(customerId?: number): Observable<MailConfig | null> {
    if (this.demoStore.isDemoMode()) {
      return of(this.demoDataService.getMailConfig());
    }
    return this.httpClient
      .get<any>(`/api/customers/${customerId ?? 'me'}/mail`)
      .pipe(map((mailConfig) => MailConfig.mapFromApiValue(mailConfig)));
  }

  getPentestMailConfigs(customerId?: number): Observable<MailConfig[]> {
    if (this.demoStore.isDemoMode()) {
      return of([this.demoDataService.getMailConfig()]);
    }
    return this.httpClient
      .get<any[]>(`/api/customers/${customerId ?? 'me'}/configs/mail`)
      .pipe(
        map((mailConfigs) => mailConfigs.map((mailConfig) => MailConfig.mapFromApiValue(mailConfig) as MailConfig)),
      );
  }

  updateCustomerMailConfig(mailConfig: MailConfig, customerId?: number): Observable<void> {
    if (this.demoStore.isDemoMode()) {
      return of();
    }
    return this.httpClient.put<void>(
      `/api/customers/${customerId ?? 'me'}/mail`,
      MailConfigUpdateRequest.mapToApiValue(mailConfig),
    );
  }

  updatePentestMailConfig(configId: string, mailConfig: MailConfig, customerId?: number): Observable<MailConfig> {
    if (this.demoStore.isDemoMode()) {
      return of(this.demoDataService.getMailConfig());
    }
    return this.httpClient.patch<MailConfig>(
      `/api/customers/${customerId ?? 'me'}/configs/${configId}/mail`,
      PentestMailConfigUpdateRequest.mapToApiValue(mailConfig),
    );
  }

  getPentestMailConfig(configId: string, customerId?: number): Observable<MailConfig> {
    if (this.demoStore.isDemoMode()) {
      return of(this.demoDataService.getMailConfig());
    }
    return this.httpClient.get<MailConfig>(`/api/customers/${customerId ?? 'me'}/configs/${configId}/mail`);
  }
}
